import LookupTableProps from 'types/lookupTableProps'
import MessageProps from 'types/MessageProps'

const appName = 'Alairo Solutions Asset Management'

const brandLogo = 'images/header-logo.png'
const brandLogoMin = 'images/header-logo-min.svg'

const apiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_URL
    : (window as any).REACT_APP_API_URL

const appPublicUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_PUBLIC_URL
    : (window as any).REACT_APP_PUBLIC_URL

const apiUrls = {
  carriers: 'carriers',
  centers: 'centers',
  comments: 'comments',
  countries: 'countries',
  customers: 'customers',
  devices: 'devices',
  deviceReplacements: 'device-replacements',
  deviceTableConfig: 'device-table-config',
  failures: 'failures',
  filters: 'filters',
  manufacturers: 'manufacturers',
  models: 'manufacturer-models',
  pdfUpdates: 'pdf-updates',
  reportConfig: 'report-configs',
  serviceStatuses: 'service-statuses',
  settings: 'settings',
  sites: 'sites',
  states: 'states',
  superadmins: 'superadmins',
  types: 'types',
  users: 'users',
  usersToCenters: 'users-to-centers',
  usersToCustomers: 'users-to-customers',
  actionBulkUpdate: 'bulk-update',
  actionDefaultSorting: 'default-sorting',
  actionSort: 'sort',
  actionSave: 'save',
  actionTemplate: 'template',
  actionChangeCustomer: 'change-customer',
  actionChangePassword: 'change-password',
  actionMyCustomer: 'my-customer',
  actionMyCustomers: 'my-customers',
  actionExport: 'export',
  actionImport: 'import',
  actionSendEmailMessage: 'send-email-message',
  actionSendEmailReport: 'send-email-report',
  actionGetSelectedCustomer: 'get-selected-customer',
  actionResetPasswordRequest: 'reset-password-request',
  actionResetPassword: 'reset-password',
  actionGetFilter: 'get',
  actionSaveFilter: 'save',
  actionToggle: 'toggle',
  actionDeviceUsages: 'device-usages',
  actionWarrantyStatuses: 'warranty-statuses',
  actionSectionNames: 'section-names',
  actionUnlock: 'unlock',
  auditLog: 'audit-log',
}

const loginViewModes = {
  login: 1,
  resetPassword: 2,
  contactUs: 3,
  setNewPassword: 4,
}

const pageSizes = [10, 15, 20, 25, 35, 50]

const defaultPageSize = 10

const defaultAxiosContentType = 'application/json' //application/form-data; charset=UTF-8

const tableColumnWidths = {
  sortColumn: '3rem',
  id: '4rem',
  show: '4rem',
  action: '5rem',
  default_soring: '8rem',
  three_actions: '10rem',
  extended_action: '19rem',
}

const emptyMessage: MessageProps = {
  text: '',
  status: '',
  display: '',
}

const lookupTablesData: Array<LookupTableProps> = [
  { appUrl: 'carriers', label: 'Carriers' },
  { appUrl: 'failure-reasons', label: 'Failure reasons' },
  { appUrl: 'manufacturers', label: 'Device Manufacturers' },
  { appUrl: 'models', label: 'Device Models' },
  { appUrl: 'service-statuses', label: 'Service Statuses' },
  { appUrl: 'types', label: 'Device Types' },
]

const settings = {
  pageSizeDevices: 'pageSize',
  pageSizeUsers: 'pageSizeUsers',
  pageSizeSites: 'pageSizeSites',
  pageSizeCostCenters: 'pageSizeCostCenters',
  pageSizeSuperadmins: 'pageSizeSuperadmins',
}

const roles = {
  admin: 'admin',
  superAdmin: 'super admin',
  user: 'user',
}

const statuses = {
  pending: 'pending',
  active: 'active',
}

enum DeviceCreateStatus {
  New = 1,
  Resurrected = 2,
  Duplicated = 3,
}

const deviceCreateStatuses = [
  { id: DeviceCreateStatus.New, name: 'New' },
  { id: DeviceCreateStatus.Resurrected, name: 'Resurrected' },
  { id: DeviceCreateStatus.Duplicated, name: 'Duplicated' },
]

enum DeviceCreateType {
  User = 1,
  UserImport = 2,
  System = 3,
}

const deviceCreateTypes = [
  { id: DeviceCreateType.User, name: 'User' },
  { id: DeviceCreateType.UserImport, name: 'User Import' },
  { id: DeviceCreateType.System, name: 'System' },
]

export {
  apiBaseUrl,
  apiUrls,
  appName,
  appPublicUrl,
  brandLogo,
  brandLogoMin,
  defaultAxiosContentType,
  defaultPageSize,
  emptyMessage,
  lookupTablesData,
  pageSizes,
  DeviceCreateStatus,
  DeviceCreateType,
  deviceCreateStatuses,
  deviceCreateTypes,
  roles,
  statuses,
  tableColumnWidths,
  loginViewModes,
  settings,
}
